import i18next, { use as tUse } from "i18next";
import { initReactI18next } from "react-i18next";

import bg from "./bg.json";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import hi from "./hi.json";
import it from "./it.json";
import ja from "./ja.json";
import nl from "./nl.json";
import pl from "./pl.json";
import pt from "./pt.json";
import ro from "./ro.json";
import ru from "./ru.json";
import sv from "./sv.json";
import uk from "./uk.json";
import zhHans from "./zhHans.json";

// eslint-disable-next-line import/no-unused-modules
export const initI18n = (): void => {
  void tUse(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
      skipOnVariables: true,
    },
    resources: {
      en: {
        translation: en,
      },
      ru: {
        translation: ru,
      },
      de: {
        translation: de,
      },
      bg: {
        translation: bg,
      },
      zh: {
        translation: zhHans,
      },
      nl: {
        translation: nl,
      },
      fr: {
        translation: fr,
      },
      hi: {
        translation: hi,
      },
      it: {
        translation: it,
      },
      ja: {
        translation: ja,
      },
      pl: {
        translation: pl,
      },
      pt: {
        translation: pt,
      },
      ro: {
        translation: ro,
      },
      es: {
        translation: es,
      },
      sv: {
        translation: sv,
      },
      uk: {
        translation: uk,
      },
    },
  });
};

// eslint-disable-next-line import/no-unused-modules
export const plural = (key: string, count: number): string => {
  const suffix: string = i18next.services.pluralResolver.getSuffix(
    i18next.language,
    count,
  );
  return `${key}${suffix.replace("_", ".")}`;
};

// eslint-disable-next-line import/no-unused-modules
export const capitalize = (s: string): string =>
  s
    .split(" ")
    .map((subStr) => subStr.charAt(0).toUpperCase() + subStr.slice(1))
    .join(" ");
